import { getConnectTruck, getConnectedTruck, getLastUpdateTime } from "@/api/eldv2";
import Vue from "vue";
import { systemInfo } from '@/shared-services'

export default {
  namespaced: true,
  state: {
    connectedColumns: [
      {
        fieldName: "truckNo",
        caption: "Truck No.",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "83px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "vin",
        caption: "Vin",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "220px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "year",
        caption: "Year",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "31px",
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "make",
        caption: "Make",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "68px",
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "model",
        caption: "Model",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "87px",
        params: {
          noClickCell: true,
        },
      },
      // {
      //   fieldName: "assetsType",
      //   caption: "Asset Type",
      //   fixed: "",
      //   textAlignment: "left",
      //   allowSort: false,
      //   minWidth: "74px",
      //   params: {
      //     noClickCell: true,
      //   },
      // },
      {
        fieldName: "vehicleType",
        caption: "Vehicle Type",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "81px",
        params: {
          noClickCell: true,
        },
        
      },
      {
        fieldName: "fuelType",
        caption: "Fuel Type",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "63px",
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "location",
        caption: "Location",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "124px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "eldAccount",
        caption: "ELD Type",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "115px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "action",
        caption: "Action",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "115px",
        type: "slot",
      }
    ],
    toConnectColumns: [
      {
        fieldName: "vin",
        caption: "Vin",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "136px",
        type: "slot",
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "year",
        caption: "Year",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "31px",
        params: {
          noClickCell: true,
        },
        formatter: (row) => {
          return row.year || '--'
        }
      },
      {
        fieldName: "make",
        caption: "Make",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "69px",
        params: {
          noClickCell: true,
        },
        formatter: (row) => {
          return row.make || '--'
        }
      },
      {
        fieldName: "model",
        caption: "Model",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "87px",
        params: {
          noClickCell: true,
        },
        formatter: (row) => {
          return row.model || '--'
        }
      },
      // {
      //   fieldName: "assetsType",
      //   caption: "Asset Type",
      //   fixed: "",
      //   textAlignment: "left",
      //   allowSort: false,
      //   minWidth: "75px",
      //   params: {
      //     noClickCell: true,
      //   },
      //   formatter: (row) => {
      //     return row.assetsType || '--'
      //   }
      // },
      {
        fieldName: "vehicleType",
        caption: "Vehicle Type",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "81px",
        params: {
          noClickCell: true,
        },
        formatter: (row) => {
          return row.vehicleType || '--'
        }
      },
      {
        fieldName: "eldAccount",
        caption: "ELD Type",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "115px",
        type: "slot",
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "fuelType",
        caption: "Fuel Type",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "61px",
        params: {
          noClickCell: true,
        },
        formatter: (row) => {
          return row.fuelType || '--'
        }
      }
    ],
    lastUpdateTime: null,
    toConnectLoading: false,
    connectedLoading: false,
    prevConnectedDate: null,
    prevToConnectDate: null,
    connectedList: [],
    toConnectList: [],
    filters: {
      search: "",
    },
  },
  mutations: {
    SET_LASTUPDATETIME(state, date = null) {
      state.lastUpdateTime = date;
    },
    SET_CONNECTEDLIST(state, payload) {
      state.connectedList = payload;
    },
    SET_CONNECTEDLIST_WS(state, list = []) {
      state.connectedList && state.connectedList.forEach(item => {
        let obj = list.find(it => it.driverId === item.fleetId)
        if (obj) {
          item.location = obj.lastKnownLocation
        } 
      })
    },
    SET_TOCONNECTLIST(state, payload) {
      state.toConnectList = payload;
    },
    SET_FILTERS(state, payload) {
      state.filters = payload;
    },
    SET_TOCONNECTLOADING(state, load) {
      state.toConnectLoading = load;
    },
    SET_CONNECTEDLOADING(state, load) {
      state.connectedLoading = load;
    },
    SET_PREVCONNECTEDDATE(state, date) {
      state.prevConnectedDate = date;
    },
    SET_PREVTOCONNECTDATE(state, date) {
      state.prevToConnectDate = date;
    },
  },
  actions: {
    updateEldDriverListByWs({commit}, list) {
      commit('SET_CONNECTEDLIST_WS', list)
    },
    updateConnectLoading({ commit }, update) {
      commit('SET_CONNECTEDLOADING', update);
    },
    async updateEldTruckData({ dispatch }, update = false) {
      await dispatch('getConnectedList', update);
      await dispatch('getToConnectList', update);
    },
    async getConnectedList({ state, commit, rootGetters, dispatch}, update = false) {
      if (!update && state.prevConnectedDate && Date.now() - state.prevConnectedDate < 60000) return;
      const fleetCompanyId = rootGetters['eld2/carrierCheck']
      if (!systemInfo.isCommand && !fleetCompanyId) {
        dispatch('updateConnectLoading', false)
        return
      }
      commit('SET_CONNECTEDLOADING', true);
      commit('SET_PREVCONNECTEDDATE', Date.now());
      await getConnectedTruck({
        blurry: state.filters.search,
        companyId: fleetCompanyId
      }).then(({ res }) => {
        const { code, message, data } = res.data;
        if (code !== 200) {
          Vue.prototype.$message.error(message);
          commit('SET_PREVCONNECTEDDATE');
          return;
        }
        commit('SET_CONNECTEDLIST', data);
      }).catch(({ error }) => {
        Vue.prototype.$message.error(error.message);
        commit('SET_PREVCONNECTEDDATE');
      }).finally(() => {
        commit('SET_CONNECTEDLOADING', false);
      });
    },
    async getToConnectList({ state, commit, rootGetters }, update = false) {
      if (!update && state.prevToConnectDate && Date.now() - state.prevToConnectDate < 60000) return;
      const fleetCompanyId = rootGetters['eld2/carrierCheck']
      if (!systemInfo.isCommand && !fleetCompanyId) {
        return 
      }
      commit('SET_TOCONNECTLOADING', true);
      commit('SET_PREVTOCONNECTDATE', Date.now());
      await getConnectTruck(fleetCompanyId).then(({ res }) => {
        const { code, message, data } = res.data;
        if (code !== 200) {
          Vue.prototype.$message.error(message);
          commit('SET_PREVTOCONNECTDATE');
          return;
        }
        commit('SET_TOCONNECTLIST', data);
      }).catch(({ error }) => {
        Vue.prototype.$message.error(error.message);
        commit('SET_PREVTOCONNECTDATE');
      }).finally(() => {
        commit('SET_TOCONNECTLOADING', false);
      });
    },
    async getLastUpdateTime({ commit, rootGetters}) {
      const fleetCompanyId = rootGetters['eld2/carrierCheck']
      if (!systemInfo.isCommand && !fleetCompanyId) {
        return
      }
      await getLastUpdateTime('truck', fleetCompanyId).then(({ res }) => {
        const { code, message, data } = res.data;
        if (code !== 200) {
          Vue.prototype.$message.error(message);
          return;
        }
        commit('SET_LASTUPDATETIME', data);
      }).catch(({ error }) => {
        Vue.prototype.$message.error(error.message);
      });
    }
  },
  getters: {
  }
}
